import { createSlice } from "@reduxjs/toolkit";
import { uploadDoctorAvatar } from "../../reducer/uploadDoctorAvatar/uploadDoctorAvatarReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const uploadDoctorAvatarSlice = createSlice({
  name: "uploadDoctorAvatar",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadDoctorAvatar.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadDoctorAvatar.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(uploadDoctorAvatar.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default uploadDoctorAvatarSlice.reducer;
